import axios from 'axios';

const request = () => window.axios || axios;

const buildBasePath = accountId =>
  `/api/v1/accounts/${accountId}/integrations/tray`;

export const fetchTrayState = accountId =>
  request().get(buildBasePath(accountId));

export const authorizeTray = (accountId, payload) =>
  request().post(`${buildBasePath(accountId)}/auth`, payload);

export const fetchTrayOrders = (accountId, contactId) =>
  request().get(`${buildBasePath(accountId)}/orders`, {
    params: { contact_id: contactId },
  });

export const fetchTrayAllOrders = (accountId, params = {}) =>
  request().get(`${buildBasePath(accountId)}/all_orders`, { params });

export const fetchTrayAbandonedCheckouts = (accountId, params = {}) =>
  request().get(`${buildBasePath(accountId)}/abandoned_checkouts`, { params });
